import React from 'react'

import collectionStyle from '../../styles/components/collection'
import horizontalCard from '../../styles/components/homePage/horizontal_card'
import dynamicCard from '../../styles/components/homePage/topStories/dynamic_card'
import rightAlignedCard from '../../styles/components/homePage/topStories/right_aligned_card'
import Ad from '../Ads/Banner'
import Card from '../Category/Card'
import Title from '../HomePage/Title'

const configureProps = (index, isMobileScreen) => {
  if (isMobileScreen) {
    return { style: index === 0 ? dynamicCard : horizontalCard }
  }

  return index < 1 ? { style: rightAlignedCard, isHeroCard: true } : { style: horizontalCard }
}

const Collection = ({ isMobileScreen, storyListByCategory, withAd = true }) => (
  <>
    {storyListByCategory?.map((item, i) => {
      return (
        <React.Fragment key={i}>
          {withAd && (
            <Ad key={`ad-${i}`} node={{ attribs: { 'data-size': 'middleboard' } }} id={`ad-banner-middle-${i}`} />
          )}
          <div className='collection' key={`${item?.category}-${i}`}>
            <Title title={item.category} />
            {item.stories.map((story, j) => {
              return <Card {...configureProps(j, isMobileScreen)} story={story} key={`${story?.id}-${i}-${j}`} />
            })}
          </div>
        </React.Fragment>
      )
    })}
    <style jsx>{collectionStyle}</style>
  </>
)

export default Collection
